import { render } from "./list-errors.vue?vue&type=template&id=518babc0&scoped=true"
import script from "./list-errors.js?vue&type=script&lang=js&external"
export * from "./list-errors.js?vue&type=script&lang=js&external"

import "./list-errors.scss?vue&type=style&index=0&id=518babc0&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518babc0"]])

export default __exports__